<!-- 记工统计列表 -->
<template>
  <div class="content" v-loading="loading">
    <div class="list">
      <BaseEmptyData v-if="!(point || wrap)"></BaseEmptyData>
      <div class="card" v-if="point || wrap">
        <header>{{ projectName }}</header>
        <div class="card_content">
          <el-row class="point_wrap" v-if="point">
            <el-col :span="12" class="work_type">
              点工
            </el-col>
            <el-col :span="12" class="work_rules">
              <div style="margin-bottom:16px">
                <span class="color666">上班：</span>{{ workTime }}
              </div>
              <div>
                <span class="color666">加班：</span>{{ point.workOverHourAll ? point.workOverHourAll+'小时' : '无加班' }}
              </div>
            </el-col>
          </el-row>
          <div class="hr_dashed" v-if="point && wrap"></div>
          <div v-if="wrap" class="bao_wrap" style="display: flex;overflow: hidden">
            <div style="width: 8em;white-space:nowrap;margin-right: 2em">包工(按量计)</div>
            <div style="width: 6em;white-space:nowrap;margin-right: 2em">{{ wrap&&wrap.wrapWorkNum }}笔</div>
            <div  style="flex:1;white-space:nowrap;text-align: right" class="salary">￥{{ wrap&&wrap.salaryAll.toFixed(2) }} 元</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {api} from '@/api/apiRecord.js'

export default {
  name: "count",
  components: {
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"), // 无数据组件
  },
  props: {
    project: {
      type: [Object, undefined],
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      point: null,
      wrap: null,
      SalaryStandardObj: {},
      loading:false
    }
  },
  methods: {
    async getList(projectNo) {
      this.loading=true
      const params = {
        projectNo: projectNo || this.project.projectNo,
        recordType: this.$route.query.type, // 类型(1:个人记工,2:班组记工3:个人记账,,4:班组记账)
      }
      const res = await api.getWorkStatistics(params)
      if (res.data.code === 200) {
        this.point = res.data.data.pointWorkStatisticsList[0] || null
        this.wrap = res.data.data.wrapWorkStatisticsList[0] || null
      }
      this.loading=false
    }
  },
  computed:{
    // 项目名
    projectName(){
      if(this.point){
        return this.point.projectName
      }
      if(this.wrap){
        return this.wrap.projectName
      }
    },
    workTime(){
      let workTime = ''
      if(this.point.workDayAll){
        workTime += this.point.workDayAll+'个工'
      }
      if(this.point.workHourAll){
         workTime += this.point.workHourAll+'小时'
      }
      if(this.point.workHourAll && this.point.workDayAll){
        workTime = workTime.replace('工','工, ')
      }
      return workTime
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;

  .select-time {
    height: 40px;
  }

  .list {
    max-height: 557px;
    overflow-y: auto;

    .card {
      border: 1px solid #E4E7ED;
      border-radius: 2px;

      header {
        padding: 0 10px;
        line-height: 40px;
        background: #F5F7FA;
      }

      .card_content {
        padding: 20px 10px;
        color: #333;
        .point_wrap {
          display: flex;


          .work_type {
            line-height: 48px;
          }
        }

        .pics {
          width: 70px;
          height: 70px;
        }
      }
    }
  }
}

.hr_dashed {
  border-top: 1px dashed #E4E7ED;
  margin: 20px 0;
}

.color666 {
  color: #666666;
}

.bao_wrap {

  .salary {
    color: #FF6600;
    font-size: 16px;
  }
}
</style>
